jQuery(document).ready(function ($) {
  $("#nen-load-more-events").click(function () {
    var button = $(this),
      nextPage = button.data("page"),
      data = {
        action: "nen_load_more_events",
        page: nextPage,
        //Offset due to the first 3 events being displayed on the page already
        max: button.data("max") - 1,
      };
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: data,
      beforeSend: function () {
        // This function will run before the AJAX request is sent
        button.text("Meer evenementen aan het laden...");
        // console.log("Loading new events...");
      },
      success: function (response) {
        // This function will run when the AJAX request is successful
        button.before(response).data("page", data.page + 1);
        button.text("Laad meer evenementen");
        // console.log("New events loaded!");
        console.log(data);

        if (data.page >= data.max) {
          button.remove();
        }
      },
    });
  });

  $("#nen-load-more-posts").click(function () {
    var button = $(this),
      nextPage = button.data("page"),
      data = {
        action: "nen_load_more_posts",
        page: nextPage,
        //Offset due to the first 3 events being displayed on the page already
        max: button.data("max") - 1,
      };
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: data,
      beforeSend: function () {
        // This function will run before the AJAX request is sent
        button.text("Meer nieuws items aan het laden...");
        // console.log("Loading new posts...");
      },
      success: function (response) {
        // This function will run when the AJAX request is successful
        button.before(response).data("page", data.page + 1);
        button.text("Laad meer nieuws items");
        // console.log("New posts loaded!");
        // console.log(data);

        if (data.page >= data.max) {
          button.remove();
        }
      },
    });
  });
});
